import React from 'react';
import { NavLink } from 'react-router-dom';

import { IPage } from 'src/interfaces';

const AboutPage: React.FC<IPage> = () => (
  <NavLink to="/" end>
    Go login
  </NavLink>
);

export default AboutPage;
